/** Compact "x ago" for recent dates, falling back to an absolute date. */
export function relativeDate(input?: string | null): string {
  if (!input) return '';
  const then = new Date(input).getTime();
  if (Number.isNaN(then)) return '';
  const diff = Date.now() - then;
  const day = 86_400_000;
  if (diff < day) return 'today';
  if (diff < 2 * day) return 'yesterday';
  if (diff < 7 * day) return `${Math.floor(diff / day)} days ago`;
  if (diff < 30 * day) {
    const w = Math.floor(diff / (7 * day));
    return `${w} week${w > 1 ? 's' : ''} ago`;
  }
  return new Date(input).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
